export default __webpack_public_path__ + "static/media/opencv.de0f7d83.webp";